// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
"use client";

import PropTypes from "prop-types";
import styled from "styled-components";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVG = styled.svg.withConfig({
  componentId: "sc-lyboom-0"
})(["min-width:", ";max-width:", ";height:", ";"], _ref => {
  let {
    $size
  } = _ref;
  return $size;
}, _ref2 => {
  let {
    $size
  } = _ref2;
  return $size;
}, _ref3 => {
  let {
    $size
  } = _ref3;
  return $size;
});
const ArrowDropDown = _ref4 => {
  let {
    size = "1em",
    color = "currentColor",
    title,
    ...props
  } = _ref4;
  return /*#__PURE__*/_jsxs(SVG, {
    ...props,
    $size: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: title ? 'img' : 'presentation',
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, " ", /*#__PURE__*/_jsx("path", {
      fill: color,
      d: "M7.24 9.69c-.404-.38-.286-.69.264-.69h8.993c.549 0 .666.31.264.69l-4.4 4.169a.527.527 0 0 1-.721 0L7.24 9.69Z",
      children: " "
    })]
  });
};
ArrowDropDown.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,
  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,
  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default ArrowDropDown;